module.exports = __webpack_public_path__ + "static/media/19ESCAP7.2d49b80e.jpg";